module.exports = __webpack_public_path__ + "fonts/VetoSans-LightItalic.279ca8bc.woff";